<template>
  <form @keyup.enter="login">
    <div class="input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">
          <i class="fa fa-user fa-fw"></i>
        </span>
      </div>
      <input
        type="text"
        name
        class="form-control input_user"
        value
        placeholder="username"
        v-model="loginData.email"
      />
    </div>
    <div class="input-group mb-2">
      <div class="input-group-append">
        <span class="input-group-text">
          <i class="fa fa-key fa-fw" aria-hidden="true"></i>
        </span>
      </div>
      <input
        type="password"
        name
        class="form-control input_pass"
        value
        placeholder="password"
        v-model="loginData.password"
      />
    </div>
    <div class="d-flex justify-content-center mt-4 login_container">
      <button type="button" name="button" class="btn login_btn" @click="login">Login</button>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      loginData: {}
    };
  },
  methods: {
    login() {
      if (this.checkInputs()) {
        this.$store
          .dispatch("auth/obtainToken", this.loginData)
          .then(this.$router.push("/app/dashboard"));
      }
      this.email = "info@gedocu.com";
      this.password = "gedocuoffice";
    },
    checkInputs() {
      Object.keys(this.loginData).forEach(key => {
        if (!this.loginData[key].length) return false;
      });
      return true;
    }
  }
};
</script>

<style scoped>
.text-white {
  color: white !important;
}
.login_btn {
  width: 93%;
  background: #fedd00 !important;
  color: black !important;
  height: calc(2.5em + 0.75rem + 2px);
}
.login_btn:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
.login_container {
  padding: 0 2rem;
}
.input-group-text {
  background: #fedd00 !important;
  color: black !important;
  border: 1px !important;
  border-radius: 0.25rem 0 0 0.25rem !important;
}
.input_user,
.input_pass:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #fedd00 !important;
}
.btn {
  display: inline-block;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1.3rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-control {
  display: block;
  width: 100%;
  height: calc(2.5em + 0.75rem + 2px);
  padding: 0.375rem 1rem;
  font-size: 1.5rem;
  font-weight: 300;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 10x solid #ced4da;
  border-radius: 0.25rem;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>